<script>
import { basketBase } from "./basketBase";

export default {
  mixins: [basketBase],
  props: {
    displayTax: Boolean,
    hideIfEmpty: Boolean
  }
};
</script>

<template>
  <div class="basket-value" v-if="items.length>0 || !hideIfEmpty">
    <div class="item total">
      <div class="label">Total:</div>
      <div class="price">{{ total | grossAmount(displayTax ? 0.2 : 0) | currency('£') }}</div>
    </div>
    <div class="item total">
      <div class="label">Shipping:</div>
      <div class="price">Free</div>
    </div>
    <hr>
    <div class="item" v-if="displayTax">
      <div class="label">NET:</div>
      <div class="price">{{ total | currency('£') }}</div>
    </div>
    <div class="item" v-if="displayTax">
      <div class="label">VAT:</div>
      <div class="price">{{ total | taxAmount(displayTax ? 0.2 : 0) | currency('£') }}</div>
    </div>
    <div class="item" v-if="discount_amount!=null">
      <div class="label">Box Price:</div>
      <div class="price">{{ original_amount ? original_amount : total | currency('£') }}</div>
    </div>
    <div class="item" v-if="discount_amount!=null">
      <div class="label">Discount:</div>
      <div class="price">-{{ (original_amount-discount_amount) | currency('£') }}</div>
    </div>
    <div class="m-2"></div>
    <div class="item text-bold">
      <div class="label">Per portion:</div>
      <div
        class="price"
      >{{ (total/items.length) | grossAmount(displayTax ? 0.2 : 0) | pricePerPerson(this.meal_preferences.people) | currency('£') }}</div>
    </div>
  </div>
</template>
